import { GroupPicker } from '@work4all/components/lib/components/entity-picker/GroupPicker';

import { useDataProvider } from '@work4all/data';

import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { LetterTemplateGroup } from '@work4all/models/lib/Classes/LetterTemplateGroup.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export interface WordLetterTemplateGroupPickerProps {
  value: Group[] | null;
  onChange: (value: LetterTemplateGroup[]) => void;
}

const LetterTemplateGroupsRequest = {
  entity: Entities.letterTemplateGroup,
  completeDataResponse: true,
  data: {
    id: null,
    name: null,
  },
};

export function WordLetterTemplateGroupPicker(
  props: WordLetterTemplateGroupPickerProps
) {
  const { value, onChange } = props;

  const response = useDataProvider<LetterTemplateGroup>(
    LetterTemplateGroupsRequest
  );

  const groups =
    response.data?.map((item) => ({
      name: item.name,
      id: item.id,
      parentId: 0,
    })) ?? null;

  return (
    <GroupPicker
      value={value?.map((item) => ({ ...item, parentId: 0 }))}
      onChange={(e) => {
        onChange(e.map((item) => ({ name: item.name, id: item.id })));
      }}
      groups={groups}
    />
  );
}
